import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "milestoneStatuses"
})
export class MilestoneStatusesPipe implements PipeTransform {
	transform(value: string): string {
		switch (value.toUpperCase()) {
			case "PENDING":
				return "Pending";
			case "COMPLETE":
				return "Completed";
			case "ERROR":
				return "Has errors";
			case "IN_PROGRESS":
				return "In progress";
		}

		return value;
	}
}
